import React, { useEffect, useState, } from 'react';
import { Link, useHistory, useParams, } from 'react-router-dom';

import axios from 'axios';
import $ from 'jquery';

import useAuth from '../../controllers/users/useAuth';
import {
    dataTableLanguaje, responseGet, globalSettings, styles, sendMessageCloseCurrentWindowAsync, buttonProcessGet, awaitDelay, separatorsNumbersSet, languageObjGet,
    isUndNullEmp, LoadingSection,
} from '../../helpers/settings';

import ApartmentUserAdd from './ApartmentUserAdd';
import ApartmentPeopleAddEditDetails from './ApartmentPeopleAddEditDetails';
import Menu from '../main/Menu';
import BuildingHeader from '../buildings/BuildingHeader';
import { validationPeopleTypeGetAsync } from '../../helpers/validations';
import { GlobalFormats } from '../../classes/main/globalFormats';
import { apartmentModelGet } from '../../models/apartments/apartment';
import { buildingModelGet } from '../../models/buildings/building';
import { peopleTypeModelGet } from '../../models/peopleTypes/peopleType';
import { apartmentUserModelGet } from '../../models/apartments/apartmentUser';
import { apartmentPeopleModelGet } from '../../models/apartments/apartmentPeople';

const { app, icons, labels, messages, react, } = globalSettings;
const { backend, } = app;
const { html: reactHtml, } = react;

const currentMethod = 'ApartmentDetails';

export default function ApartmentDetails({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region vriables
    let result;
    let dataObj = {};
    let headerObj = {};
    const { id, } = useParams();
    const auth = useAuth();
    const history = useHistory();
    //const userRole = checkIfUserIsMaster({email: auth?.user?.email || '', languageId: '', subMethod: '', })?.result;
    const [processType, setProcessType] = useState();
    const [showLoading, setShowLoading] = useState({ building: true, apartment: true, apartmentUsers: true, apartmentPeoples: true, });
    //const [showData, setShowData] = useState(false);
    //#endregion variables

    //#region apartment
    const [apartment, setApartment] = useState(apartmentModelGet({}));
    //#endregion apartment

    //#region building
    let buildingTwo = buildingModelGet({});
    const [building, setBuilding] = useState(buildingModelGet({}));
    const [buildingFloors, setBuildingFloors] = useState([]);
    const [buildingAliquotPercentage, setBuildingAliquotPercentage] = useState(false);
    //#endregion building

    //#region artment users
    let apartmentUsers = [];
    const dtApartmentUsersId = 'dtApartmentUsers';
    const [showModalApartmentUsers, setShowModalApartmentUsers] = useState(false);
    const [apartmentUsersTwo] = useState([]);
    //#endregion apartment users

    //#region apartment peoples
    let apartmentPeoples = [];
    const dtApartmentPeoplesId = 'dtApartmentPeoples';
    const [showModalApartmentPeoples, setShowModalApartmentPeoples] = useState(false);
    const [peopleTypes, setPeopleTypes] = useState([peopleTypeModelGet({})]);
    const [dtApartmentPeoplesRowIndexTwo, setDtApartmentPeoplesRowIndexTwo] = useState(0);
    const [apartmentPeople, setApartmentPeople] = useState({});
    //#endregion apartment peoples

    //#region others
    const controls = {
        buttons: {
            save: {
                className: 'btn btn-outline-warning mx-1',
                id: 'btnSave',
            },
            back: {
                className: 'btn btn-outline-success',
                id: 'btnBack',
            },
        },
        checkBox: {
            // topLevel: {
            //     id: 'chkTopLevel',
            //     className: 'icheck-primary',
            // },
            // lowLevel: {
            //     id: 'chkLowLevel',
            //     className: 'icheck-primary',
            // }
        },
        dataTables: {
            apartmentUsers: {
                buttons: {
                    add: {
                        id: 'btnApartmentuserAdd',
                        className: 'btn btn-outline-success float-right btn-sm',
                    },
                },
                icons: {
                    add: {
                        id: 'icoApartmentuserAdd',
                        className: globalSettings?.icons?.plusCircle,
                    },
                },
                inputs: {
                    search: {
                        id: `${dtApartmentUsersId}_filter input`,
                        className: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtApartmentUsersId}_length select`,
                        className: '',
                    },
                },
                spinners: {
                    add: {
                        id: 'spApartmentuserAdd',
                        className: '',
                    },
                },
            },
            apartmentPeoples: {
                buttons: {
                    add: {
                        id: 'btnApartmentPeoplesAdd',
                        className: 'btn btn-outline-success float-right btn-sm',
                    },
                },
                icons: {
                    add: {
                        id: 'icoApartmentPeoplesAdd',
                        className: globalSettings?.icons?.plusCircle,
                    },
                },
                inputs: {
                    search: {
                        id: `${dtApartmentPeoplesId}_filter input`,
                        className: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtApartmentPeoplesId}_length select`,
                        className: '',
                    },
                },
                spinners: {
                    add: {
                        id: 'spApartmentPeoplesAdd',
                        className: '',
                    },
                },
            },
        },
        icons: {
            save: {
                id: 'iconSave',
                className: globalSettings?.icons?.save,
            },
            back: {
                id: 'iconBack',
                className: globalSettings?.icons?.arrowCircleLeft,
            },
        },
        inputs: {
            identifier: {
                id: 'inputIdentifier',
                className: 'form-control',
            },
            aliquot: {
                id: 'inputAliquot',
                className: 'form-control text-right',
            },
            parkingStalls: {
                id: 'inputParkingStalls',
                className: 'form-control',
            },
            phoneNumber: {
                id: 'inputPhoneNumber',
                className: 'form-control',
            },
        },
        selects: {
            floor: {
                id: 'selFloor',
                className: 'form-select',
            },
        },
        spinners: {
            save: {
                id: 'spSave',
                className: '',
            },
            back: {
                id: 'spBack',
                className: '',
            },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion others

    //#region apartment (methods)
    const buildingFloorsGet = ({
        subMethod = '', }) => {
        const currentMethod = 'buildingFloorsGet';
        let response = responseGet();
        try {
            let buildingFloorsLocal = [];
            if (!isUndNullEmp({ data: buildingTwo, subMethod: currentMethod, })?.result) {
                if (buildingTwo?.lowLevel) {
                    buildingFloorsLocal?.push({ label: 'PB', value: 0, });
                }

                if (buildingTwo?.floors > 0) {
                    for (let index = 0; index < buildingTwo?.floors; index++) {
                        buildingFloorsLocal?.push({ label: `${labels?.floor?.[languageObj?.id]} ${index + 1}`, value: index + 1, });
                    }
                }

                if (buildingTwo?.topLevel && buildingTwo?.floors > 0) {
                    buildingFloorsLocal?.push({ label: 'PH', value: (buildingTwo?.floors + 1), });
                }
            }
            setBuildingFloors(buildingFloorsLocal);
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }
    //#endregion apartment (methods)

    //#region aparment users (methods)
    const dataTableAparmentUsersSet = ({
        subMethod = '',
    }) => {
        const currentMethod = 'dataTableAparmentUsersSet';
        let response = responseGet();
        try {
            $(`#${dtApartmentUsersId}`)?.DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.firstName?.[languageObj?.id], width: '30%', },
                    { title: labels?.lastName?.[languageObj?.id], width: '30%', },
                    { title: labels?.email?.[languageObj?.id], width: '35%', },
                    { title: labels?.process?.[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                order: [[0, 'asc', 1, 'asc']],
                ordering: true,
                responsive: true,
                lengthChange: true,
                autoWidth: false,
                //}).buttons().container().appendTo(`#${dtApartmentUsersId}_wrapper .col-md-6:eq(0)`);
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const apartmentUsersLoad = async ({
        apartmentUsers_ = [],
        subMethod = '',
    }) => {
        const currentMethod = 'apartmentUsersLoad';
        let response = responseGet()
        try {
            apartmentUsers_?.forEach((detail,) => {
                apartmentUsers.push([
                    detail?.user?.firstName,
                    detail?.user?.lastName,
                    detail?.user?.email,
                    buttonProcessGet({
                        id: detail.id,
                        description: `${detail?.user?.firstName}, ${detail?.user?.lastName}`,
                        showDetails: false,
                        labelDetails: labels?.detail?.[languageObj?.id],
                        enabledDetails: false,
                        showEdit: false,
                        labelEdit: labels?.edit?.[languageObj?.id],
                        enabledEdit: false,
                        showDelete: true,
                        labelDelete: labels?.delete?.[languageObj?.id],
                        enabledDelete: false,
                        processButtons: [],
                        subMethod: currentMethod,
                    }).result
                ]);
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }
    //#endregion aparment users (methods)

    //#region apartments peoples (methods)
    const dataTableAparmentPeoplesSet = ({ subMethod = '', }) => {
        const currentMethod = 'dataTableAparmentPeoplesSet';
        let response = responseGet();
        try {
            $(`#${dtApartmentPeoplesId}`)?.DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.firstName?.[languageObj?.id], width: '30%', },
                    { title: labels?.lastName?.[languageObj?.id], width: '30%', },
                    { title: labels?.type?.[languageObj?.id], width: '35%', },
                    { title: labels?.process?.[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                order: [[0, 'asc'], [1, 'asc']],
                ordering: true,
                responsive: true,
                lengthChange: true,
                autoWidth: false,
                //}).buttons().container().appendTo(`#${dtApartmentPeoplesId}_wrapper .col-md-6:eq(0)`);
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const apartmentPeoplesEditDetailsGetAsync = async ({
        id_ = '',
        description = '',
        rowIndex = 0,
        processType_ = 0,
        subMethod = '',
    }) => {
        const currentMethod = 'apartmentPeoplesEditDetailsGetAsync';
        let response = responseGet();
        try {
            //#region variables
            let peopleTypesLocal = [];
            let apartmentPeopleLocal = {};
            //#region responseIsWarning
            let responseIsWarning = responseGet();
            responseIsWarning.msgType = 1;
            responseIsWarning.isWarning = true;
            //responseIsWarning.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod, })?.result) {
                //responseIsWarning.msgText += `Sub method: ${subMethod}<br/>`;
            }
            //#endregion responseIsWarning
            //#endregion variables

            //controlsStatusSet({ processType: 4, subMethod: currentMethod, });
            setShowLoading({ building: false, apartment: false, apartmentUsers: false, apartmentPeoples: true, });

            //#region apartment get people
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                    languageId: languageObj?.id
                },
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlApartmentPeoples}/${id_}`,
            };

            result = await axios?.get(
                headerObj?.url,
                headerObj,
            );

            response = result.data;

            if (!response?.isSuccess || response?.isWarning) {
                //controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                setShowLoading({ building: false, apartment: false, apartmentUsers: false, apartmentPeoples: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            apartmentPeopleLocal = response?.result;
            setApartmentPeople(apartmentPeopleLocal);
            //#endregion apartment get people

            //#region data get (people types)
            response = await validationPeopleTypeGetAsync({
                buildingId: buildingTwo?.id || building?.id,
                limit: 0,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                //controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                setShowLoading({ building: false, apartment: false, apartmentUsers: false, apartmentPeoples: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            peopleTypesLocal = response?.result;
            //#endregion data get (people types)

            setPeopleTypes(peopleTypesLocal);
            //setProcessType(1);
            setProcessType(processType_);
            setDtApartmentPeoplesRowIndexTwo(rowIndex);
            setShowModalApartmentPeoples(true);
            //controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            setShowLoading({ building: false, apartment: false, apartmentUsers: false, apartmentPeoples: false, });
        } catch (ex) {
            //controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            setShowLoading({ building: false, apartment: false, apartmentUsers: false, apartmentPeoples: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const peopleTypeGet = ({
        peopleTypeId = {},
        peopleTypes = [],
        subMethod = '', }) => {
        const currentMethod = 'peopleTypeGet';
        let response = responseGet();
        try {
            const peopleTypeLocal = peopleTypes?.find(({ id }) => id === peopleTypeId);
            if (isUndNullEmp({ data: peopleTypeLocal, subMethod: currentMethod, })?.result) {
                response.msgType = 1;
                response.isWarning = true;
                response.result = globalSettings?.labels?.notFound?.[languageObj?.id];
            } else {
                response.result = peopleTypeLocal?.description;
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            response.result = `Error: ${currentMethod}`;
        }
        return response;
    }

    const apartmentPeoplesLoad = async ({
        apartmentPeoples_ = [],
        subMethod = '',
    }) => {
        const currentMethod = 'apartmentPeoplesLoad';
        let response = responseGet()
        try {
            apartmentPeoples_?.forEach((detail,) => {
                apartmentPeoples.push([
                    detail?.firstName,
                    detail?.lastName,
                    detail?.peopleType?.description,
                    buttonProcessGet({
                        id: detail?.id,
                        description: `${detail?.firstName}, ${detail?.lastName}`,
                        showDetails: true,
                        labelDetails: labels?.detail?.[languageObj?.id],
                        enabledDetails: true,
                        showEdit: true,
                        labelEdit: labels?.edit?.[languageObj?.id],
                        enabledEdit: false,
                        showDelete: true,
                        labelDelete: labels?.delete?.[languageObj?.id],
                        enabledDelete: false,
                        processButtons: [],
                        subMethod: currentMethod,
                    })?.result
                ])
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }
    //#endregion apartments peoples (methods)

    //#region methods (others)
    const dataGetAsync = async ({
        subMethod = ''
    }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            setShowLoading({ building: true, apartment: true, apartmentUsers: true, apartmentPeoples: true, });

            //#region variables
            apartmentUsers = [];
            apartmentPeoples = [];

            let apartmentLocal = apartmentModelGet({});
            let apartmentUsersLocal = [apartmentUserModelGet({})];
            let apartmentPeoplesLocal = [apartmentPeopleModelGet({})];
            //#endregion variables

            //#region dataTable set and query code
            response = dataTablesSet({
                dtApartmentUsers: true,
                dtApartmentPeoples: true,
                queryCodeSet_: true,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion dataTable set and query code

            //#region data get
            //#region apartment get
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                id: id,
                limit: 0,
                ordersBy: [],
                conditionals: [],
                method: backend?.methods?.apartments.apartmentWithDetails,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlApartments}/`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data || {};

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, apartment: false, apartmentUsers: false, apartmentPeoples: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            buildingTwo = response?.result?.building || {};
            apartmentLocal = response?.result?.apartment || {};
            apartmentUsersLocal = response?.result?.apartmentUsers || [];
            apartmentPeoplesLocal = response?.result?.apartmentPeoples || [];

            setBuilding(buildingTwo);
            setBuildingAliquotPercentage(!isUndNullEmp({ data: buildingTwo?.settings?.accountsReceivable?.aliquotPercentage, subMethod: currentMethod, })?.result ?
                buildingTwo?.settings?.accountsReceivable?.aliquotPercentage : false);

            if (!isUndNullEmp({ data: apartmentLocal?.id, subMethod: currentMethod, })?.result) {
                setApartment(apartmentLocal);

                //#region apartmentUsers load
                response = await apartmentUsersLoad({
                    apartmentUsers_: apartmentUsersLocal,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    setShowLoading({ building: false, apartment: false, apartmentUsers: false, apartmentPeoples: false, });
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }
                //#endregion apartmentUsers load

                //#region apartmentPeoples load
                response = await apartmentPeoplesLoad({
                    apartmentPeoples_: apartmentPeoplesLocal,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    setShowLoading({ building: false, apartment: false, apartmentUsers: false, apartmentPeoples: false, });
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }
                //#endregion apartmentPeoples load
            } else {
                setShowLoading({ building: false, apartment: false, apartmentUsers: false, apartmentPeoples: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: 1,
                    msgText: messages?.theRecordCannotBeLocated?.[languageObj?.id],
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion apartment get

            //#region building get
            response = buildingFloorsGet({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, apartment: false, apartmentUsers: false, apartmentPeoples: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion building get
            //#endregion data get

            //#region load datatable
            $(`#${dtApartmentUsersId}`)?.DataTable()?.rows?.add(apartmentUsers)?.draw();
            $(`#${dtApartmentPeoplesId}`)?.DataTable()?.rows?.add(apartmentPeoples)?.draw();
            //#endregion load datatable

            setShowLoading({ building: false, apartment: false, apartmentUsers: false, apartmentPeoples: false, });
        } catch (ex) {
            setShowLoading({ building: false, apartment: false, apartmentUsers: false, apartmentPeoples: false, });

            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const queryCodeSet = ({ subMethod = '', }) => {
        const currentMethod = 'queryCodeSet';
        let response = responseGet();
        try {
            //#region variables
            let method = '';
            let idLocal = '';
            let rowIndex = 0;
            let dtRowIndex = 0;
            let description = '';
            //#endregion variables

            //#region data table (Apartment Users)
            $(`#${dtApartmentUsersId} tbody`)?.on('click', 'tr', 'td', async function (e) {
                e?.preventDefault();
                rowIndex = $(`#${dtApartmentUsersId}`)?.DataTable()?.row(this)?.index();
                dtRowIndex = !isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result ? rowIndex : dtRowIndex;
                if (!isUndNullEmp({ data: dtRowIndex, subMethod: currentMethod, })?.result) {
                    method = e?.target?.attributes?.method?.value || '';
                    idLocal = e?.target?.attributes?.id?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (method) {
                        case 'delete':
                            //apartmentUserDeleteGetAsync({ id_: idLocal, description: description, rowIndex: dtRowIndex, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion data table (Apartment Users)

            //#region data table (iventories)
            $(`#${dtApartmentPeoplesId} tbody`)?.on('click', 'tr', 'td', async function (e) {
                e?.preventDefault();
                rowIndex = $(`#${dtApartmentPeoplesId}`)?.DataTable()?.row(this)?.index();
                dtRowIndex = !isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result ? rowIndex : dtRowIndex;
                if (!isUndNullEmp({ data: dtRowIndex, subMethod: currentMethod, })?.result) {
                    method = e?.target?.attributes?.method?.value || '';
                    idLocal = e?.target?.attributes?.id?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (method) {
                        case 'edit':
                            //apartmentPeoplesEditDetailsGetAsync({ id_: idLocal, description: description, rowIndex: dtRowIndex, processType_: 1, subMethod: currentMethod, });
                            break;
                        case 'details':
                            apartmentPeoplesEditDetailsGetAsync({ id_: idLocal, description: description, rowIndex: dtRowIndex, processType_: 2, subMethod: currentMethod, });
                            break;
                        case 'delete':
                            //apartmentPeopleDeleteGetAsync({ id_: idLocal, description: description, rowIndex: dtRowIndex, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion data table (iventories)
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const dataTablesSet = ({
        dtApartmentUsers = false,
        dtApartmentPeoples = false,
        queryCodeSet_ = false,
        subMethod = '',
    }) => {
        const currentMethod = 'dataTablesSet';
        let response = responseGet();
        try {
            if (dtApartmentUsers) {
                response = dataTableAparmentUsersSet({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) {
                    return response;
                }
            }

            if (dtApartmentPeoples) {
                response = dataTableAparmentPeoplesSet({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) {
                    return response;
                }
            }

            if (queryCodeSet_) {
                response = queryCodeSet({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) {
                    return response;
                }
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const goToBackAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'goToBackAsync';
        let response = responseGet();
        try {
            e?.preventDefault();

            controlsStatusSet({ processType: 2, subMethod: currentMethod, });
            await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
            history?.push(backend?.urlApartments);
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    // $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    // $(`#${controls?.buttons?.save?.id}`)?.removeClass();
                    // $(`#${controls?.spinners?.save?.id}`)?.removeClass();

                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.buttons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.removeClass();

                    $(`#${controls?.dataTables?.apartmentUsers?.icons?.add?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.apartmentUsers?.buttons?.add?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.apartmentUsers?.spinners?.add?.id}`)?.removeClass();

                    $(`#${controls?.dataTables?.apartmentPeoples?.icons?.add?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.apartmentPeoples?.buttons?.add?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.apartmentPeoples?.spinners?.add?.id}`)?.removeClass();

                    // $(`#${controls?.icons?.save?.id}`)?.addClass(controls?.icons?.save?.className);
                    // $(`#${controls?.buttons?.save?.id}`)?.addClass(controls?.buttons?.save?.className);
                    // $(`#${controls?.spinners?.save?.id}`)?.addClass(controls?.spinners?.save?.className);

                    $(`#${controls?.icons?.back?.id}`)?.addClass(controls?.icons?.back?.className);
                    $(`#${controls?.buttons?.back?.id}`)?.addClass(controls?.buttons?.back?.className);
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(controls?.spinners?.back?.className);

                    $(`#${controls?.dataTables?.apartmentUsers?.icons?.add?.id}`)?.addClass(controls?.dataTables?.apartmentUsers?.icons?.add?.className);
                    $(`#${controls?.dataTables?.apartmentUsers?.buttons?.add?.id}`)?.addClass(controls?.dataTables?.apartmentUsers?.buttons?.add?.className);
                    $(`#${controls?.dataTables?.apartmentUsers?.spinners?.add?.id}`)?.addClass(controls?.dataTables?.apartmentUsers?.spinners?.add?.className);

                    $(`#${controls?.dataTables?.apartmentPeoples?.icons?.add?.id}`)?.addClass(controls?.dataTables?.apartmentPeoples?.icons?.add?.className);
                    $(`#${controls?.dataTables?.apartmentPeoples?.buttons?.add?.id}`)?.addClass(controls?.dataTables?.apartmentPeoples?.buttons?.add?.className);
                    $(`#${controls?.dataTables?.apartmentPeoples?.spinners?.add?.id}`)?.addClass(controls?.dataTables?.apartmentPeoples?.spinners?.add?.className);
                    break;
                case 1:
                    //$(`#${controls?.buttons?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 3:
                    $(`#${controls?.dataTables?.apartmentUsers?.icons?.add?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.apartmentUsers?.spinners?.add?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 4:
                    $(`#${controls?.dataTables?.apartmentPeoples?.icons?.add?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.apartmentPeoples?.spinners?.add?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            // $(`#${controls?.selects?.floor?.id}`).attr('disabled', (processType !== 0));
            // $(`#${controls?.inputs?.identifier?.id}`).attr('readOnly', (processType !== 0));
            // $(`#${controls?.inputs?.aliquot?.id}`).attr('readOnly', (processType !== 0));
            // $(`#${controls?.inputs?.parkingStalls?.id}`).attr('readOnly', (processType !== 0));
            // $(`#${controls?.inputs?.phoneNumber?.id}`).attr('readOnly', (processType !== 0));

            //#region old code
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlRegisterStatus));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion old code

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            //#region dataTables
            $(`#${controls?.dataTables?.apartmentUsers?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.dataTables?.apartmentUsers?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));
            $(`#${controls?.dataTables?.apartmentPeoples?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.dataTables?.apartmentPeoples?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));
            //#endregion dataTables

            if (processType !== 0) {
                //$(`#${controls?.buttons?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                // $(`#${controls?.dataTables?.apartmentUsers?.buttons?.add?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                // $(`#${controls?.dataTables?.apartmentPeoples?.buttons?.add?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({
            subMethod: 'form - onLoad',
        });
    }, [id]) //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods (others)

    return (
        <div>
            <Menu viewName='process' process='apartments' />

            <div className='content-wrapper'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2'>
                            <div className='col-sm-6'>
                                <h6 className='m-0'>{labels?.apartment?.[languageObj?.id]}</h6>
                            </div>{/* /.col */}
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right'>
                                    <li className='breadcrumb-item'><Link to='/'>{labels?.home?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item'><Link to={backend?.urlApartments}>{labels?.apartments?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item active'>{labels?.apartment?.[languageObj?.id]}</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        <div className='row'>
                            <div className='col-12'>

                                {/*buildings*/}
                                <BuildingHeader buildingsId={''}
                                    building={building}
                                    buildings={[]}
                                    btnSyncDisabled={null}
                                    methodGetAsync={null}
                                    processType={1}
                                    headerSectionValues={{}}
                                    showLoading={showLoading?.building}
                                    languageObj={languageObj} />

                                {/*apartment*/}
                                <form onSubmit={(e) => null}>
                                    <div className='card card-outline card-primary shadow-lg'>
                                        <LoadingSection alt='loadingSection'
                                            className={reactHtml?.overlay?.darkTextWhite}
                                            showText={true}
                                            text={messages?.processing?.[languageObj?.id]}
                                            height={25}
                                            hidden={!showLoading?.apartment}
                                            width={25}
                                            languageId={languageObj?.id}
                                            subMethod={currentMethod} />

                                        {/*card header*/}
                                        <div className='card-header'>
                                            <h6 className='card-title'>
                                                <img alt={labels?.apartment?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.apartmentsLogo}></img>
                                                - {labels?.apartment?.[languageObj?.id]} ({labels?.details?.[languageObj?.id]})
                                            </h6>
                                            <div className='card-tools'>
                                                <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                    <i className={icons?.minus}></i>
                                                </button>
                                                {/* <button tooltip='tooltip' title={labels?.create?.[languageObj?.id]} className='btn btn-outline-success float-right btn-sm' onClick={()=> localElevatorAddGetAsync()}><i className={icons?.plusCircle}></i></button> */}
                                            </div>
                                        </div>

                                        {/*card body*/}
                                        <div className='card-body text-muted'>
                                            {/*apartment data*/}
                                            <div className='row'>

                                                <div className='col-md-4'>
                                                    <div className='form-group'>
                                                        <div className='row'>
                                                            <div className='col-md-4'>
                                                                <b>{labels?.floor?.[languageObj?.id]}:</b>
                                                            </div>
                                                            <div className='col-md-8'>
                                                                {buildingFloors?.find(({ value, }) => value === apartment?.floor)?.label || ''}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='col-md-4'>
                                                    <div className='form-group'>
                                                        <div className='row'>
                                                            <div className='col-md-4'>
                                                                <b>{labels?.identifier?.[languageObj?.id]}:</b>
                                                            </div>
                                                            <div className='col-md-8'>
                                                                {apartment.identifier || ''}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='col-md-4'>
                                                    {buildingAliquotPercentage ?
                                                        <div className='form-group'>
                                                            <div className='row'>
                                                                <div className='col-md-4'>
                                                                    <b>% {labels?.aliquot?.[languageObj?.id]}:</b>
                                                                </div>
                                                                <div className='col-md-8'>
                                                                    {
                                                                        separatorsNumbersSet({
                                                                            number: apartment?.aliquotPercentage,
                                                                            withDecimals: true,
                                                                            consoleLogErrorShow: true,
                                                                            subMethod: currentMethod,
                                                                        })?.result
                                                                    }
                                                                </div>
                                                            </div>

                                                        </div> :
                                                        <></>
                                                    }
                                                </div>
                                            </div>

                                            <div className='row'>

                                                <div className='col-md-4'>
                                                    <div className='form-group'>
                                                        <div className='row'>
                                                            <div className='col-md-8'>
                                                                <b>{labels?.parkingStalls?.[languageObj?.id]}:</b>
                                                            </div>
                                                            <div className='col-md-4'>
                                                                {apartment.parkingPlace || ''}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='col-md-4'>
                                                    <div className='form-group'>
                                                        <div className='row'>
                                                            <div className='col-md-4'>
                                                                <b>{labels?.phone?.[languageObj?.id]}:</b>
                                                            </div>
                                                            <div className='col-md-8'>
                                                                {apartment?.phoneNumber || ''}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='col-md-4'>
                                                    <div className='form-group text-right'>
                                                        {/* <button className='btn btn-outline-success'
                                                            tooltip='tooltip'
                                                            title={labels?.back?.[languageObj?.id]}
                                                            type='reset'
                                                            onClick={(e) => localGoBack(e)}>
                                                            <i className={icons?.arrowCircleLeft}></i>
                                                        </button> */}
                                                        <button id={controls?.buttons?.back?.id}
                                                            className={controls?.buttons?.back?.className}
                                                            tooltip='tooltip'
                                                            title={globalSettings?.labels?.back?.[languageObj?.id]}
                                                            type='reset'
                                                            onClick={(e) => goToBackAsync({ e: e, subMethod: 'btn - goToBack', })}>
                                                            <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                                                        </button>
                                                    </div>
                                                </div>

                                            </div>
                                        </div> {/*card body*/}

                                        {/*card footer*/}
                                        {/* <div className='card-footer'></div> */}

                                    </div>{/*card*/}

                                </form>

                                {/*apartment users*/}
                                <div className='card card-outline card-primary shadow-lg'>
                                    <LoadingSection alt='loadingSection'
                                        className={reactHtml?.overlay?.darkTextWhite}
                                        showText={true}
                                        text={messages?.processing?.[languageObj?.id]}
                                        height={25}
                                        hidden={!showLoading?.apartmentUsers}
                                        width={25}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    {/*card header*/}
                                    <div className='card-header'>
                                        <h6 className='card-title'>
                                            <img alt={labels?.tenant?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.keyHouse}></img> - {labels?.owner?.[languageObj?.id]} / {labels?.tenant?.[languageObj?.id]}
                                        </h6>
                                        <div className='card-tools'>
                                            <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                <i className={icons?.minus}></i>
                                            </button>
                                        </div>
                                    </div>

                                    {/*card body*/}
                                    <div className='card-body'>
                                        <div className='row'>
                                            <div className='col-md-12'>
                                                <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                                                    <table id={dtApartmentUsersId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div> {/*card body*/}

                                    {/*card footer*/}
                                    {/* <div className='card-footer'></div> */}

                                </div>{/*card*/}

                                {/*apartment peoples*/}
                                <div className='card card-outline card-primary shadow-lg'>
                                    <LoadingSection alt='loadingSection'
                                        className={reactHtml?.overlay?.darkTextWhite}
                                        showText={true}
                                        text={messages?.processing?.[languageObj?.id]}
                                        height={25}
                                        hidden={!showLoading?.apartmentPeoples}
                                        width={25}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    {/*card header*/}
                                    <div className='card-header'>
                                        <h6 className='card-title'>
                                            <img alt={labels?.occupants?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.familyLogo}></img> - {labels?.occupants?.[languageObj?.id]}
                                        </h6>
                                        <div className='card-tools'>
                                            <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                <i className={icons?.minus}></i>
                                            </button>
                                        </div>
                                    </div>

                                    {/*card body*/}
                                    <div className='card-body'>
                                        <div className='row'>
                                            <div className='col-md-12'>
                                                <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                                                    <table id={dtApartmentPeoplesId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div> {/*card body*/}

                                    {/*card footer*/}
                                    {/* <div className='card-footer'></div> */}

                                </div>{/*card*/}

                            </div>{/*col*/}
                        </div>{/*row*/}

                    </div>{/* /.container-fluid */}
                </section>
                {/* /.content */}

            </div>

            {showModalApartmentUsers ?
                <ApartmentUserAdd $={$}
                    auth={auth}
                    showModal={showModalApartmentUsers}
                    setShowModal={setShowModalApartmentUsers}
                    apartment={apartment}
                    apartmentUsers={apartmentUsersTwo}
                    dtId={dtApartmentUsersId}
                    languageObj={languageObj} />
                :
                <></>
            }

            {showModalApartmentPeoples ?
                <ApartmentPeopleAddEditDetails $={$}
                    auth={auth}
                    showModal={showModalApartmentPeoples}
                    setShowModal={setShowModalApartmentPeoples}
                    apartmentPeople={apartmentPeople}
                    setApartmentPeople={setApartmentPeople}
                    peopleTypes={peopleTypes}
                    peopleTypeGet={peopleTypeGet}
                    dtId={dtApartmentPeoplesId}
                    dtRowIndex={dtApartmentPeoplesRowIndexTwo}
                    processType={processType}
                    languageObj={languageObj} />
                :
                <></>
            }
        </div>
    )
}